import React, { useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Trophy, Calendar, Menu, X, ArrowLeft } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useChampionship } from "@/contexts/ChampionshipContext";
import { useTheme } from "@/contexts/ThemeContext";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { championshipId } = useParams();
  const navigate = useNavigate();
  const { selectedChampionship } = useChampionship();
  
  const isActive = (path) => location.pathname.includes(path);
  
  const navLinks = [
    { path: `/championship/${championshipId}/home`, label: "Home", icon: null },
    { path: `/championship/${championshipId}/classifica`, label: "Classifica", icon: Trophy },
    { path: `/championship/${championshipId}/calendario`, label: "Calendario", icon: Calendar },
  ];
  
  const championship = selectedChampionship || {
    name: "Serie D Maschile Gir. A",
    series: "Serie D",
    group: "A"
  };
  
  return (
    <nav className="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Back Button and Logo */}
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/')}
              className="hover:bg-primary/10"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <Link to={`/championship/${championshipId}/home`} className="flex items-center space-x-2 group">
              <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center transition-transform group-hover:scale-110">
                <Trophy className="w-6 h-6 text-primary-foreground" />
              </div>
              <div className="hidden sm:block">
                <div className="font-bold text-lg leading-tight">Volley Puglia</div>
                <div className="text-xs text-muted-foreground">{championship.series} - Girone {championship.group}</div>
              </div>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <Link key={link.path} to={link.path}>
                  <Button
                    variant={isActive(link.path) ? "default" : "ghost"}
                    className="gap-2"
                  >
                    {Icon && <Icon className="w-4 h-4" />}
                    {link.label}
                  </Button>
                </Link>
              );
            })}
            <ThemeToggle />
          </div>
          
          {/* Mobile Menu Button */}
          <div className="flex items-center gap-2 md:hidden">
            <ThemeToggle />
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </Button>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-2">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                >
                  <Button
                    variant={isActive(link.path) ? "default" : "ghost"}
                    className="w-full justify-start gap-2"
                  >
                    {Icon && <Icon className="w-4 h-4" />}
                    {link.label}
                  </Button>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </nav>
  );
};
